import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import LoginPage from "../ui/pages/authentication/LoginPage";
import ShowLoginInteractor from "../interactor/authentication/ShowLoginInteractor";
import { Layouts } from "../common/Constants";
import LogoutPage from "../ui/pages/authentication/LogoutPage";
import LogoutInteractor from "../interactor/authentication/LogoutInteractor";
import PasswordChangePage from "../ui/pages/authentication/PasswordChangePage";
import ShowChangePasswordInteractor from "../interactor/authentication/ShowChangePasswordInteractor";
import ShowVerificationPageInteractor from "../interactor/authentication/ShowVerificationPageInteractor";
import VerificationPage from "../ui/pages/authentication/VerificationPage";
import ForgottenPasswordPage from "../ui/pages/authentication/ForgottenPasswordPage";
import ShowResetPasswordInteractor from "../interactor/authentication/ShowResetPasswordInteractor";

export default class AuthenticationArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/login",
        page: this.createPage({
          Page: LoginPage,
          action: this.showLoginPage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/change-password",
        page: this.createPage({
          Page: PasswordChangePage,
          action: this.showChangePassword.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/changepassword",
        page: this.createPage({
          Page: PasswordChangePage,
          action: this.showChangePassword.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/reset-password",
        page: this.createPage({
          Page: ForgottenPasswordPage,
          action: this.showResetPassword.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/dologout",
        page: this.createPage({
          Page: LogoutPage,
          action: this.logout.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/verification",
        page: this.createPage({
          Page: VerificationPage,
          action: this.showVerificationPage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      }
    );
  }

  public showLoginPage({
    username,
    redirect
  }: {
    username?: string;
    redirect?: string;
  }) {
    return this.application.container
      .resolve<ShowLoginInteractor>("showLogin")
      .execute(username, redirect);
  }

  public showChangePassword({
    username,
    oldPassword,
    token
  }: {
    username: string;
    oldPassword: string;
    token: string;
  }) {
    return this.application.container
      .resolve<ShowChangePasswordInteractor>("showChangePassword")
      .execute(username, oldPassword, token);
  }

  public showResetPassword() {
    return this.application.container
      .resolve<ShowResetPasswordInteractor>("showResetPassword")
      .execute();
  }

  public logout() {
    return this.application.container
      .resolve<LogoutInteractor>("logout")
      .execute();
  }

  public showVerificationPage({ redirect }: { redirect?: string }) {
    return this.application.container
      .resolve<ShowVerificationPageInteractor>("showVerificationPage")
      .execute(redirect);
  }
}
